/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Ai_Prompt_PlaceholderInputs */

const cs_property_ai_prompt_placeholder = /** @type {(inputs: Property_Ai_Prompt_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`např. jasnější denní světlo, srovnat horizon, scandi dubový nábytek…`)
};

const en_property_ai_prompt_placeholder = /** @type {(inputs: Property_Ai_Prompt_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. brighter daylight, straighten horizon, scandi oak furniture…`)
};

/**
* | output |
* | --- |
* | "e.g. brighter daylight, straighten horizon, scandi oak furniture…" |
*
* @param {Property_Ai_Prompt_PlaceholderInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_ai_prompt_placeholder = /** @type {((inputs?: Property_Ai_Prompt_PlaceholderInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Ai_Prompt_PlaceholderInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_ai_prompt_placeholder(inputs)
	return cs_property_ai_prompt_placeholder(inputs)
});